import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { StatComponent } from './stat/stat.component';

import { NgbTypeaheadModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { StatSingleComponent } from './statSingle/statSingle.component';

@NgModule({
  declarations: [StatComponent,StatSingleComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbTypeaheadModule,
    NgbPaginationModule
  ],
  exports: [StatComponent,StatSingleComponent]
})
export class WidgetModule { }
